import React, { useEffect, useState } from 'react';
import SelectedProductCard from '../Card/SelectedProductCard';
import { useTranslation } from 'react-i18next';
import ModalBottomWrapper from '../Modal/ModalBottomWrapper';
import BasicButton from '../Button/BasicButton';
import useApi from '../../hooks/useApi';
import useDialog from '../../hooks/useDialog';
import useGetBeatInfo from '../../hooks/useGetBeatInfo';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { languageState } from '../../recoil/language/languageAtom';
import ERROR_CODES from '../../constants/errorCodes';
import PRODUCT_TYPES from '../../constants/productTypes';
import PAYMENT_TYPES from '../../constants/paymentTypes';
import SelectedStarbeatProductCard from '../Card/SelectedStatbeatProductCard';
import { countryState } from '../../recoil/country/countryAtom';

const PaymentItemsWrapper = ({ productDetailData, selectedItems, paymentProductType }) => {
  const [selectedPaymentType, setSelectedPaymentType] = useState(PAYMENT_TYPES.CREDIT_CARD);
  const [isChecked, setIsChecked] = useState(false);
  const [isTooltipShow, setIsTooltipShow] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalPriceStarbeat, setTotalPriceStarbeat] = useState(0);
  const [totalBenefit, setTotalBenefit] = useState(0);
  const [infoOptionsArray, setInfoOptionsArray] = useState([]);
  const [email, setEmail] = useState('');
  const [inputValues, setInputValues] = useState([]);
  const [isPurchased, setIsPurchased] = useState(false);
  const { showDialog, hideDialog } = useDialog();
  const accessToken = localStorage.getItem('access_token');
  const countryData = useRecoilValue(countryState);
  const selectedLanguage = useRecoilValue(languageState);

  const { t } = useTranslation();
  const api = useApi();
  const navigate = useNavigate();

  const { beatInfo } = useGetBeatInfo(accessToken, countryData?.country);
  const APP_DOMAIN_V1 = process.env.REACT_APP_DOMAIN_V1;

  const validateSelectAndAgree = () => {
    const isAllInputsFilled = inputValues.every((input) => input.value.trim() !== '');
    return isAllInputsFilled && selectedPaymentType && isChecked && email;
  };

  const handleOptionChange = (e) => {
    setSelectedPaymentType(e.target.value);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleTooltip = () => {
    setIsTooltipShow(!isTooltipShow);
  };

  // 이메일 유효성 검사
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const purchaseProduct = async () => {
    if (!isValidEmail(email)) {
      alertInvalidEmail();
      return;
    }

    const optionsString = getInputValuesString();

    // payment_type 따라서 currency 결정
    const currency =
      selectedPaymentType === PAYMENT_TYPES.STAR_BEAT ? PAYMENT_TYPES.STAR_BEAT : productDetailData?.currency;

    // 현재 url(결제 결과 url에서 사용)
    const currentUrl = window.location.href;

    // 비디오 상품의 경우 payload
    let purchaseInfo = {
      version: productDetailData?.version,
      payment_type: selectedPaymentType,
      currency: currency,
      options: optionsString,
      email: email,
      url: currentUrl,
    };

    // 디지털 상품의 경우 payload
    if (productDetailData?.product_type === PRODUCT_TYPES.DIGITAL) {
      const detailItems = selectedItems.map((item) => ({
        item_id: item.item_id,
        quantity: item.count,
        version: item.version,
      }));

      purchaseInfo = {
        ...purchaseInfo,
        detail_items: detailItems,
      };
    }

    try {
      const response = await api.post(`mubeat_live/product/${productDetailData?.id}/buy`, purchaseInfo, {
        headers: {
          Authorization: `${accessToken}`,
          'user-locale': productDetailData?.currency === 'KRW' ? 'KO' : 'EN',
        },
      });
      if (selectedPaymentType === PAYMENT_TYPES.STAR_BEAT) {
        // 스타비트의 경우 별도의 url 없이 직접 라우팅 변경
        navigate('/purchase-complete');
      } else {
        // 스타비트가 아닌 경우 페이레터 연동
        let paymentUrl;
        paymentUrl = response?.data?.online_url;
        window.location.href = paymentUrl; // 현재창

        // 테스트용 코드
        // let windowFeatures = 'width=800,height=600,left=100,top=100';
        // window.open(paymentUrl, '_blank', windowFeatures);
      }
    } catch (error) {
      const errorCode = error.response && error.response.data && error.response.data.code;
      if (errorCode === ERROR_CODES.notEnoughStarbeat) {
        alertNotEnoughStarbeat();
      } else if (errorCode === ERROR_CODES.purchaseDuplicateRequest) {
        setIsPurchased(true);
        alertAlreadyPurchased();
      } else if (errorCode === ERROR_CODES.purchaseLimitExceeded) {
        alertMaxLimit();
      } else if (errorCode === ERROR_CODES.saleEndedUnavailable) {
        alertEndPurchase();
      } else if (errorCode === ERROR_CODES.purchaseSoldOut) {
        alertSoldOut();
      } else if (errorCode === ERROR_CODES.pendingPaymentInProgress) {
        alertPending();
      } else if (errorCode === ERROR_CODES.productVersionUpdated) {
        navigate('/page-error');
      } else if (errorCode === ERROR_CODES.purchaseGatewayFailed) {
        navigate(`/purchase-fail?url=${currentUrl}`);
      } else {
        console.log(errorCode);
        // 스타비트의 경우 라우터 직접 이동
        if (selectedPaymentType === PAYMENT_TYPES.STAR_BEAT) navigate(`/purchase-fail?url=${currentUrl}`);
      }
    }
  };

  const purchaseStarbeat = async () => {
    if (!isValidEmail(email)) {
      alertInvalidEmail();
      return;
    }

    // payment_type 따라서 currency 결정
    const currency = productDetailData?.currency;

    const currentUrl = window.location.href;

    // 스타비트웹결제 상품의 경우 payload
    let purchaseInfo = {
      version: productDetailData?.version,
      payment_type: selectedPaymentType,
      currency: currency,
      email: email,
      url: currentUrl,
    };

    try {
      const response = await api.post(`purchase/web_star_beat/product/${productDetailData?.pk}/buy`, purchaseInfo, {
        headers: {
          Authorization: `${accessToken}`,
          'user-locale': productDetailData?.currency === 'KRW' ? 'KO' : 'EN',
        },
      });

      let paymentUrl;
      paymentUrl = response?.data?.online_url;
      window.location.href = paymentUrl; // 현재창

      // 테스트용 코드
      // let windowFeatures = 'width=800,height=600,left=100,top=100';
      // window.open(paymentUrl, '_blank', windowFeatures);
    } catch (error) {
      const errorCode = error.response && error.response.data && error.response.data.code;
      if (errorCode === ERROR_CODES.pendingPaymentInProgress) {
        alertPending();
      } else if (errorCode === ERROR_CODES.productVersionUpdated) {
        navigate('/page-error');
      } else if (errorCode === ERROR_CODES.purchaseGatewayFailed) {
        navigate(`/purchase-fail?url=${currentUrl}`);
      } else if (errorCode === ERROR_CODES.notFoundItem) {
        navigate('/page-error');
      } else {
        console.log(errorCode);
      }
    }
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
  };

  const handleInputChange = (index, newValue) => {
    const newInputValues = [...inputValues];
    newInputValues[index].value = newValue;
    setInputValues(newInputValues);
  };

  const getInputValuesString = () => {
    return inputValues.map((input) => input.value).join(',');
  };

  const alertNotEnoughStarbeat = () => {
    showDialog({
      dialogType: 'ConfirmDialog',
      dialogProps: {
        title: t('not_enough_star_beats_msg'),
        confirmText: t('charge'),
        cancelText: t('return'),
        handleConfirm: () => {
          navigate('/starbeat-purchase');
          hideDialog();
        },
        handleClose: () => {
          console.log('Close!');
        },
      },
    });
  };

  const alertAlreadyPurchased = () => {
    showDialog({
      dialogType: 'AlertDialog',
      dialogProps: {
        title: t('already_purchased_msg'),
        confirmText: t('confirm'),
      },
    });
  };
  const alertPending = () => {
    showDialog({
      dialogType: 'AlertDialog',
      dialogProps: {
        title: t('pay_pending_msg'),
        confirmText: t('confirm'),
      },
    });
  };
  const alertInvalidEmail = () => {
    showDialog({
      dialogType: 'AlertDialog',
      dialogProps: {
        title: t('invalid_email_msg'),
        confirmText: t('confirm'),
      },
    });
  };

  const alertMaxLimit = () => {
    showDialog({
      dialogType: 'AlertDialog',
      dialogProps: {
        title: t('max_limit_msg'),
        confirmText: t('confirm'),
      },
    });
  };

  const alertEndPurchase = () => {
    showDialog({
      dialogType: 'AlertDialog',
      dialogProps: {
        title: t('end_purchase_msg'),
        confirmText: t('confirm'),
      },
    });
  };
  const alertSoldOut = () => {
    showDialog({
      dialogType: 'AlertDialog',
      dialogProps: {
        title: t('sold_out_msg'),
        confirmText: t('confirm'),
      },
    });
  };

  useEffect(() => {
    let newTotalPrice; // 결제금액 합계
    let newTotalStarbeatPrice; // 결제스타비트 합계
    let newBenefit; // 적립 하트비트 합계
    // 비디오 합계
    if (productDetailData?.product_type === PRODUCT_TYPES.VIDEO) {
      newTotalPrice = productDetailData?.price;
      newTotalStarbeatPrice = productDetailData?.price_starbeat;
      newBenefit = productDetailData?.benefit_amount;
      // 디지털 합계
    } else if (productDetailData?.product_type === PRODUCT_TYPES.DIGITAL) {
      newTotalPrice = selectedItems.reduce((sum, option) => sum + option.item_price * (option.count || 1), 0);
      newTotalStarbeatPrice = selectedItems.reduce(
        (sum, option) => sum + option.item_price_starbeat * (option.count || 1),
        0,
      );
      newBenefit = selectedItems.reduce((sum, option) => sum + option.item_benefit * (option.count || 1), 0);
    }
    setTotalPrice(newTotalPrice);
    setTotalPriceStarbeat(newTotalStarbeatPrice);

    // 스타비트 웹결제의 경우
    if (paymentProductType === 'starbeat') setTotalPrice(productDetailData?.price);
    setTotalBenefit(newBenefit);

    // 해당 옵션 배열로 변환(비디오, 디지털 동일)
    const options = productDetailData.options ? productDetailData.options.split(',') : [];
    setInfoOptionsArray(options);
  }, [selectedItems, productDetailData.options]);

  useEffect(() => {
    const initialInputValues = infoOptionsArray.map((option) => ({
      name: option,
      value: '',
    }));
    setInputValues(initialInputValues);
  }, [infoOptionsArray]);

  // 국내/해외 결제에 따라 초깃값 변경
  useEffect(() => {
    if (countryData && countryData.country) {
      setSelectedPaymentType(countryData.country === 'KR' ? PAYMENT_TYPES.CREDIT_CARD : PAYMENT_TYPES.CREDIT_CARD_MPI);
    }
  }, [countryData]);

  return (
    <>
      <div className={'payment-items-wrapper'}>
        {/* 선택된 상품 */}
        <div className='selected-products-wrapper'>
          <div className='payment-item-title-group'>
            <h3 className={'payment-item-title'}>{t('selected_products')}</h3>
          </div>
          <div className='selected-product-card-wrapper'>
            {/* 비디오, 디지털상품 결제의 경우 해당 카드 노출 */}
            {productDetailData?.product_type === PRODUCT_TYPES.VIDEO ? (
              <SelectedProductCard productDetailData={productDetailData} selectedPaymentType={selectedPaymentType} />
            ) : null}
            {productDetailData?.product_type === PRODUCT_TYPES.DIGITAL
              ? selectedItems?.map((item) => (
                  <SelectedProductCard
                    productDetailData={productDetailData}
                    selectedPaymentType={selectedPaymentType}
                    key={item.item_id}
                    item={item}
                  />
                ))
              : null}
            {/* 스타비트 결제의 경우 스타비트결제카드 노출 */}
            {paymentProductType === 'starbeat' ? (
              <SelectedStarbeatProductCard productDetailData={productDetailData} />
            ) : null}
          </div>
          <div className='selected-products-total-price-wrapper'>
            <div className='total-price-group'>
              <span className={'total-price-label'}>{t('total_price')}</span>
              <span
                className={`total-price-info ${selectedPaymentType === PAYMENT_TYPES.STAR_BEAT ? 'type-starbeat' : ''}`}
              >
                {selectedPaymentType === PAYMENT_TYPES.STAR_BEAT ? (
                  <span className={'total-price-icon-group'}>
                    <i className={'icon icon-star-point'} />
                  </span>
                ) : null}
                {selectedPaymentType === PAYMENT_TYPES.STAR_BEAT
                  ? totalPriceStarbeat?.toLocaleString()
                  : totalPrice?.toLocaleString()}
                {selectedPaymentType !== PAYMENT_TYPES.STAR_BEAT ? <>&nbsp;{productDetailData.currency}</> : null}
              </span>
            </div>
            {/* 스타비트결제상품이 아닌 경우만 노출 */}
            {paymentProductType !== 'starbeat' ? (
              <div className='bonus-heart-beat-group'>
                <span className={'bonus-heart-beat-label'}>{t('bonus_heart_beats')} : </span>
                <span className={'bonus-heart-beat-info'}>{totalBenefit?.toLocaleString()}</span>
              </div>
            ) : null}
          </div>
        </div>
        {/* 구매자 정보 */}
        {/* CMS 입력값이 있는 경우만 노출, 없는 경우 서버에서 빈 string response, 랜더링 시 프론트에서 빈 배열 return 작업 */}

        <div className='purchaser-info-wrapper'>
          <div className='payment-item-title-group'>
            <h3 className={'payment-item-title'}>{t('purchaser_information')}</h3>
            <p className={'payment-item-desc'}>{t('please_input')}.</p>
          </div>
          <div className='purchaser-info-input-wrapper'>
            <div className='default-input-group purchaser-info-input-group focus-no-zoom-input-parent-group'>
              <label className={'default-label'} htmlFor='require-email'>
                E-mail
              </label>
              <input
                maxLength={50}
                className={'default-input focus-no-zoom-input'}
                type='text'
                id='require-email'
                value={email}
                onChange={handleEmailChange}
              />
            </div>

            {infoOptionsArray.map((item, index) => {
              return (
                <div
                  key={index}
                  className='default-input-group purchaser-info-input-group focus-no-zoom-input-parent-group'
                >
                  <label className={'default-label'} htmlFor={item}>
                    {item}
                  </label>
                  <input
                    maxLength={50}
                    className={'default-input focus-no-zoom-input'}
                    type='text'
                    id={item}
                    value={inputValues[index]?.value || ''}
                    onChange={(e) => {
                      handleInputChange(index, e.target.value);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>

        {/* 결제 방식 */}
        <div className='select-payment-method-wrapper'>
          <div className='payment-item-title-group type-border'>
            <h3 className={'payment-item-title'}>{t('select_payment_method')}</h3>
          </div>
          <div className='custom-radio-group'>
            {/* 스타비트결제상품이 아닌 경우만 노출 */}
            {paymentProductType !== 'starbeat' ? (
              <div className='radio-label-group'>
                <label
                  className={`radio-label cursor-pointer ${
                    selectedPaymentType === PAYMENT_TYPES.STAR_BEAT ? 'selected' : ''
                  }`}
                >
                  <input
                    className={'custom-radio-input'}
                    type='radio'
                    value={PAYMENT_TYPES.STAR_BEAT}
                    checked={selectedPaymentType === PAYMENT_TYPES.STAR_BEAT}
                    onChange={handleOptionChange}
                  />
                  <span className='radio-span-custom' />
                  <span className={'radio-span-label'}>
                    {t('star_beats')}
                    <span className={'radio-span-desc'}>
                      {t('current_star_beat_balance')} : {beatInfo?.data?.star_beat?.toLocaleString()}
                    </span>
                  </span>
                </label>
              </div>
            ) : null}
            {/* 해외 신용카드 결제 */}
            {countryData?.country !== 'KR' ? (
              <>
                <div className='radio-label-group'>
                  <label
                    className={`radio-label cursor-pointer ${
                      selectedPaymentType === PAYMENT_TYPES.CREDIT_CARD_MPI ? 'selected' : ''
                    }`}
                  >
                    <input
                      className={'custom-radio-input'}
                      type='radio'
                      value={PAYMENT_TYPES.CREDIT_CARD_MPI}
                      checked={selectedPaymentType === PAYMENT_TYPES.CREDIT_CARD_MPI}
                      onChange={handleOptionChange}
                    />
                    <span className='radio-span-custom' />
                    <span className={'radio-span-label'}>{t('credit_card')} (VISA/Master Card/JCB)</span>
                  </label>
                </div>
                <div className='radio-label-group'>
                  <label
                    className={`radio-label cursor-pointer ${
                      selectedPaymentType === PAYMENT_TYPES.CREDIT_CARD_AMEX ? 'selected' : ''
                    }`}
                  >
                    <input
                      className={'custom-radio-input'}
                      type='radio'
                      value={PAYMENT_TYPES.CREDIT_CARD_AMEX}
                      checked={selectedPaymentType === PAYMENT_TYPES.CREDIT_CARD_AMEX}
                      onChange={handleOptionChange}
                    />
                    <span className='radio-span-custom' />
                    <span className={'radio-span-label'}>{t('credit_card')} (AmEx)</span>
                  </label>
                </div>
              </>
            ) : null}
            {/* 국내 신용카드 결제 */}
            {countryData?.country === 'KR' ? (
              <div className='radio-label-group'>
                <label
                  className={`radio-label cursor-pointer ${
                    selectedPaymentType === PAYMENT_TYPES.CREDIT_CARD ? 'selected' : ''
                  }`}
                >
                  <input
                    className={'custom-radio-input'}
                    type='radio'
                    value={PAYMENT_TYPES.CREDIT_CARD}
                    checked={selectedPaymentType === PAYMENT_TYPES.CREDIT_CARD}
                    onChange={handleOptionChange}
                  />
                  <span className='radio-span-custom' />
                  <span className={'radio-span-label'}>{t('credit_card')}</span>
                </label>
              </div>
            ) : null}

            {/* 국내에서 페이팔 라디오버튼 미노출 */}
            {countryData?.country !== 'KR' ? (
              <div className='radio-label-group'>
                <label
                  className={`radio-label cursor-pointer ${
                    selectedPaymentType === PAYMENT_TYPES.PAYPAL ? 'selected' : ''
                  }`}
                >
                  <input
                    className={'custom-radio-input'}
                    type='radio'
                    value={PAYMENT_TYPES.PAYPAL}
                    checked={selectedPaymentType === PAYMENT_TYPES.PAYPAL}
                    onChange={handleOptionChange}
                  />
                  <span className='radio-span-custom' />
                  <span className={'radio-span-label radio-span-icon-label'}>
                    <figure className='logo-paypal-group'>
                      <img src='/logo_paypal.png' alt='paypal logo' className='logo-paypal-img' />
                    </figure>
                  </span>
                </label>
              </div>
            ) : null}
          </div>
        </div>
        {/* 개인정보 처리 동의 */}
        <div className='select-payment-checkbox-wrapper'>
          <div className='select-payment-checkbox-top-wrapper'>
            <div className='custom-checkbox-group'>
              <label className='checkbox-label-group'>
                <input
                  type='checkbox'
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  className='custom-checkbox-input'
                />
                <span className='custom-checkbox-checkmark'>
                  <i className={`icon icon-check ${isChecked ? 'icon-check-wh' : 'icon-check-gray'}`} />
                </span>
                <span className='custom-checkbox-text'>{t('consent_to_providing_personal_information')}</span>
              </label>
            </div>
            <div className='custom-checkbox-notice-group'>
              <button className={'button-default custom-checkbox-button'} type={'button'} onClick={handleTooltip}>
                {t('read_more')}
                <i className={`icon icon-dropdown mb-show ${isTooltipShow ? 'is-show' : ''} `} />
              </button>
              {/* floating tooltip */}
              <div className={`tooltip-group ${isTooltipShow ? 'is-show' : ''}`}>
                <div className='tooltip-top-group'>
                  <h5 className={'tooltip-title mb-hide'}>{t('personal_information_collection_notice')}</h5>
                  <button
                    type={'button'}
                    className={'button-default tooltip-close-button mb-hide'}
                    aria-label={'Close'}
                    onClick={() => {
                      setIsTooltipShow(false);
                    }}
                  >
                    <i className={'icon icon-close-gray'} />
                  </button>
                </div>
                <ul className={'tooltip-content-group'}>
                  {/* 앱과 통일성 있게 맞추기 위해 object tag 사용 */}
                  {selectedLanguage ? (
                    <object
                      className={'custom-object'}
                      data={`${APP_DOMAIN_V1}/view/live/terms/privacy?lang=${selectedLanguage.toUpperCase()}`}
                      type='text/html'
                    ></object>
                  ) : null}

                  {/*<li className={'tooltip-content-list'}>*/}
                  {/*  {t('purpose_of_collection_label')}: {t('purpose_of_collection_info')}*/}
                  {/*</li>*/}
                  {/*<li className={'tooltip-content-list'}>*/}
                  {/*  {t('collected_information_label')}: {t('collected_information_info')}*/}
                  {/*</li>*/}
                  {/*<li className={'tooltip-content-list'}>*/}
                  {/*  {t('information_storage_label')}: {t('information_storage_info')}*/}
                  {/*</li>*/}
                </ul>
              </div>
            </div>
          </div>
          <div className='select-payment-checkbox-bottom-wrapper'>
            <p className={'checkbox-label-desc'}>
              {paymentProductType !== 'starbeat'
                ? t('refunds_and_cancellations')
                : t('refunds_and_cancellations_check_again')}
              .
            </p>
          </div>
        </div>
      </div>
      <ModalBottomWrapper>
        <div className='payment-modal-bottom-button-wrapper'>
          <BasicButton
            buttonTxt={t('purchase_pay')}
            buttonType={'primary'}
            disabled={!validateSelectAndAgree() || isPurchased}
            onClick={paymentProductType !== 'starbeat' ? purchaseProduct : purchaseStarbeat}
          />
        </div>
      </ModalBottomWrapper>
    </>
  );
};

export default PaymentItemsWrapper;
